module.exports = __webpack_public_path__ + "img/15.ff30cc81.png";